
<webhook-form-query-select *ngIf="flowData.codecompany==0" [field]="fieldCfgCompany" [mainformGroup]="form" [rootForm]="form" (change)="changeCompany($event,fieldCfgCompany)" style="width: 200px; margin-right: 20px; margin-bottom: 10px;">
</webhook-form-query-select>
<nz-radio-group [(ngModel)]="debug" nzSize="large" nzButtonStyle="solid">
    <label nz-radio-button nzValue="RUNNING" [nzDisabled]="disableStart" (click)="startFlow()">
        <nz-icon nzType="play-circle" nzTheme="twotone"  [nzTwotoneColor]="'#52c41a'" style="margin-right: 8px;"></nz-icon>
        {{'play'|translateTA}}
    </label>
    <label nz-radio-button nzValue="CONTINUE" [nzDisabled]="disableStepping" (click)="continueFlow()">
        <nz-icon nzType="step-forward" nzTheme="fill" style="margin-right: 8px;"></nz-icon>
        {{'continue'|translateTA}}
    </label>
    <label nz-radio-button nzValue="STOPPED" [nzDisabled]="!disableStart" (click)="stopFlow()">
        <nz-icon nzType="stop" nzTheme="twotone" [nzTwotoneColor]="'#eb2f96'"  style="margin-right: 8px;"></nz-icon>
        {{'stop'|translateTA}}
    </label>
</nz-radio-group>

        
